var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app header-section"},[_c('div',{staticClass:"dmRespRow"},[_c('div',{staticClass:"dmRespCol large-12 medium-12 small-12"},[(_vm.publicToken)?_c('SearchResult',{attrs:{"token":_vm.publicToken,"requestParams":_vm.requestParams,"widgetConfig":_vm.widgetConfig}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }